import { render, staticRenderFns } from "./ResultView.vue?vue&type=template&id=795348c0&scoped=true&"
import script from "./ResultView.vue?vue&type=script&lang=js&"
export * from "./ResultView.vue?vue&type=script&lang=js&"
import style0 from "./ResultView.vue?vue&type=style&index=0&id=795348c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795348c0",
  null
  
)

export default component.exports